import script from "./realtime-traffic.vue?vue&type=script&setup=true&lang=ts"
export * from "./realtime-traffic.vue?vue&type=script&setup=true&lang=ts"

import "./realtime-traffic.vue?vue&type=style&index=0&id=6c73f20f&lang=scss"

const __exports__ = script;

export default __exports__